import React, { useState, useEffect } from 'react';
import '../css/ContactUsList.css';
import apiClient from '../apiClient';
import { useAuth } from '../context/AuthContext';

const ContactUsList = () => {
  const [contacts, setContacts] = useState({});
  const [filter, setFilter] = useState({
    call: "",
    remark: ""
  })

  const fetchContacts = async (page = 1) => {
    try {
      const response = await apiClient.get(`/user/students-list?page=${page}&callStatus=${filter.call}&remarks=${filter.remark}`);
      setContacts(response.data.data);
      setMessageShow({
        status: "success",
        message: "Successfully get student data."
      });
    } catch (error) {
      setMessageShow({
        status: "error",
        message: "Something went wrong. Please contact admin."
      });
      setTimeout(()=>{
        getUserDetails()

      },5000)

      console.error('Error fetching contacts:', error);
    }
  };
  const { logout } = useAuth();
      
  const handleLogout = () => {
    logout();
    window.location.reload();
  };

  const [userDetails, setUserDetails] = useState({})
  const getUserDetails = async (page = 1) => {
    try {
      const response = await apiClient.get(`/user/calling-user`);
      setUserDetails(response.data.data);
    } catch (error) {
      handleLogout()
      console.error('Error fetching contacts:', error);
    }
  };

  useEffect(() => {
    getUserDetails()
    fetchContacts(1);
  }, []);

  const studentResponce = [
    'Not interested',
    'Not picked up',
    'Number busy',
    'Switched off',
    'Wrong number',
    'Call back requested',
    'Interested in next batch',
    'Already enrolled elsewhere',
    'Language issue',
    'Call disconnected',
    'Interested but needs clarification',
    'Requires parents approval',
    'Follow-up scheduled',
    'Converted to enrollment',
    'Other'
  ]

  const whatsapptext = "Hello! Are you interested in learning web development or digital marketing? Join live classes at OgWebGuru.com with expert guidance, class notes, and interview preparation. Let's build your future together!  Start now: www.ogwebguru.com";
  
  const callType = [
    'Called', 'NotCall'
  ]

  const [messageShow, setMessageShow] = useState({
    status: "",
    message: ""
  })

  const handleSave = async (data) => {
    try {
      setMessageShow({
        status: "",
        message: ""
      });
      await apiClient.put(`/user/students-access/${data?.studentAccessId}`, data);
      setMessageShow({
        status: "success",
        message: "Successfully saved student data."
      });
    } catch (error) {
      setMessageShow({
        status: "error",
        message: "Something went wrong. Please contact admin."
      });
      setTimeout(()=>{
        getUserDetails()
      },5000)
      console.error('Error saving changes:', error);
    }
  };

  useEffect(() => {
    if (messageShow?.message) {
      setTimeout(() => {
        setMessageShow({
          status: "",
          message: ""
        });
      }, 3000);
    }
  }, [messageShow]);

  return (
    <div className="contact-us-list">
      {userDetails?.username && <h2 style={{
        textAlign: "center",
        color: " #28a745",
        borderBottom: "solid"
      }}> Welcome {userDetails?.name} ({userDetails?.username})</h2>}
      {messageShow?.message &&
        <div className={`toast-message ${messageShow.status}`}>
          <h4>{messageShow.message}</h4>
        </div>
      }
      <h1>Student Data</h1>
      <div style={{ display: "flex", gap: "10px" }}>
        <select onChange={(e) => {
          setFilter({
            ...filter,
            remark: e.target.value
          })
        }}
          value={filter?.remark || null} style={{ width: "auto" }} class="form-select form-select-sm" aria-label="Small select example">
          <option value={""}>--Select Remarks--</option>
          {studentResponce?.map((res, index) =>
            <option value={res}>{res}</option>
          )}
        </select>
        <select onChange={(e) => {
          setFilter({
            ...filter,
            call: e.target.value
          })
        }} value={filter?.call || null} style={{ width: "auto" }} class="form-select form-select-sm" aria-label="Small select example">
          <option value={""}>--Select Called Type--</option>
          {callType?.map((res, index) =>
            <option value={res}>{res}</option>
          )}
        </select>

        <button onClick={() => fetchContacts(1)}>Filter</button>
      </div>
      <table border="1" style={{ width: '100%', marginTop: '20px', textAlign: 'left' }}>
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Phone</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {contacts?.students?.map((contact, index) => (
            <tr key={contact.studentAccessId}>
              <td>{((contacts?.currentPage - 1) * contacts?.pageSize) + index + 1}
              </td>
              <td>{contact?.recode?.phoneNumber}
                <a href={`tel:${contact?.recode?.phoneNumber}`} title="Call Now" style={{ marginLeft: '10px' }}>
                  <i className="fa fa-phone-square" style={{ fontSize: "24Px" }} aria-hidden="true"></i>
                </a>
                <a
                  href={`https://wa.me/${contact?.recode?.phoneNumber}?text=${encodeURIComponent(
                    whatsapptext
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Chat on WhatsApp"
                  style={{ marginLeft: '10px' }}
                >
                  <i className="fa fa-whatsapp" style={{ fontSize: "24Px" }} aria-hidden="true"></i>
                </a>
              </td>
              <td >
                <div style={{ display: "flex", gap: "10px" }}>
                  <select
                    onChange={(e) => {
                      setContacts(prevContacts => ({
                        ...prevContacts,
                        students: prevContacts.students.map(res =>
                          res?.studentAccessId === contact?.studentAccessId ? { ...res, remarks: e.target.value } : res
                        )
                      }));

                    }}
                    value={contact?.remarks || null} style={{ width: "auto" }} class="form-select form-select-sm" aria-label="Small select example">
                    <option value={null}>--Select Remarks--</option>
                    {studentResponce?.map((res, index) =>
                      <option value={res}>{res}</option>
                    )}
                  </select>
                  <select onChange={(e) => {
                    setContacts(prevContacts => ({
                      ...prevContacts,
                      students: prevContacts.students.map(res =>
                        res?.studentAccessId === contact?.studentAccessId ? { ...res, callStatus: e.target.value } : res
                      )
                    }));

                  }} value={contact?.callStatus || null} style={{ width: "auto" }} class="form-select form-select-sm" aria-label="Small select example">
                    <option value={null}>--Select Called Status--</option>
                    {callType?.map((res, index) =>
                      <option value={res}>{res}</option>
                    )}
                  </select>
                  {/* {contact?.customRemarks && <button type="button" class="btn btn-warning">{contact?.customRemarks}</button>} */}
                  <input onChange={(e) => {
                    setContacts(prevContacts => ({
                      ...prevContacts,
                      students: prevContacts.students.map(res =>
                        res?.studentAccessId === contact?.studentAccessId ? { ...res, customRemarks: e.target.value } : res
                      )
                    }));

                  }} style={{ width: 'auto' }} class="form-control" value={contact?.customRemarks || ""} placeholder='Enter Remark' />
                </div>

              </td>
              <td>
                <button onClick={() => {
                  handleSave({
                    studentAccessId: contact?.studentAccessId,
                    customRemarks: contact?.customRemarks,
                    callStatus: contact?.callStatus,
                    remarks: contact?.remarks,
                  })
                }}>Save</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: 'flex', gap: "10px" }}>
        <button type="button" class="btn btn-outline-primary" onClick={() => {
          contacts?.currentPage > 1 && fetchContacts(contacts?.currentPage - 1)
        }}>Previous</button>
        <button type="button" class="btn btn-outline-primary">{contacts?.currentPage}</button>
        <button type="button" class="btn btn-outline-primary" onClick={() => {
          contacts?.totalPages > contacts?.currentPage && fetchContacts(contacts?.currentPage + 1)
        }}>Next</button>
      </div>
      <p>Total Page : {contacts?.totalPages || 0}</p>
      <p>Total Student : {contacts?.total || 0}</p>
    </div>
  );
};

export default ContactUsList;
